module.exports = __webpack_public_path__ + "static/block-and-tackle-logo-4bb6accdf71d2a0662006c8a03f5eaa4.svg";